import { BaseInput, Card, BaseDropdown, BaseButton, BaseCheckbox , IcoBtn, Selector, PhotosManager, tplManager} from "../components/index";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(Card.name, Card);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(IcoBtn.name, IcoBtn);
    Vue.component(Selector.name, Selector);
    Vue.component(PhotosManager.name, PhotosManager);
    Vue.component(tplManager.name, tplManager);
  }
};

export default GlobalComponents;
